import axios from "axios"
import bridge from "./bridge"
class CajasGG {
    getCajas() {
        let sql = `SELECT idpuesto, Idsesion, estado, fechaapertura, horaapertura, fechacierre, horacierre, NROTURNO , TotalGeneral
        FROM sesion 
        WHERE fechaapertura >= DATEADD(month, -3, GETDATE())`
        return bridge.post('v1/recordset',sql)
    }
}
class CajasMi {
    getCajas() {
        let sql = `SELECT idpuesto, Idsesion, estado, fechaapertura, horaapertura, fechacierre,horacierre, NROTURNO , TotalGeneral
        FROM _gg_sesion where licence_id = ${window.licenceid} and fechaapertura >= DATE_SUB(CURDATE(), INTERVAL 3 MONTH)`
        return axios.post(process.env.VUE_APP_baseURL+'recordset/',{query:sql},{headers:{Authorization:process.env.VUE_APP_AUTH_TOKEN}})
    }
}
export function Cajas() {
    if (window.datasource=="MI") {
        return new CajasMi
    } else {
        return new CajasGG
    }
}
